import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
/* 反馈接口 */
import home from "./modules/home";
import myquiz from "./modules/myquiz";
import store from '../store';
export const constantRouter = [
  ...home,
  ...myquiz,
  /* 网络断网 */
  {
    path: "*",
    name: "notfound",
    meta: { title: "404" },
    component: () => import("@/components/notfound.vue")
  }
];
const router = new Router({
  mode: "history", // require service support
  routes: constantRouter
  // scrollBehavior: () => ({
  //   y: 0
  // }),
});
router.beforeEach((to, from, next) => {
  store.commit('showNav', to);
  if (to.name === 'FormList' && from.name === 'MyQuiz') {
    next({ name: 'home'});
    return;
  }
  next();
})
// router.afterEach(to => {
//   if (to.meta && to.meta.title) {
//     // 可能需要考虑兼容性
//     document.title = to.meta.title;
//   }
// });

export default router;
